import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { ChapterShell } from "../ChapterShell";
import { FadeUp } from "../Reveal";

const PORTFOLIO = [
  { name: "Rapilif", mol: "Silodosin" },
  { name: "Rapilif D", mol: "Silodosin + Dutasteride" },
  { name: "Castramide", mol: "Bicalutamide 50mg · Prostate Cancer" },
];

const CHAIN = ["Insight", "Positioning", "Message", "Execution", "Prescription", "Business Impact"];

export const ChapterThree = () => (
  <ChapterShell
    n="03"
    id="chapter-3"
    era="2016 – 2017 · IPCA"
    title="Becoming a Product Builder"
    quote="A product becomes a brand only when insight travels all the way to business impact."
  >
    <div className="grid grid-cols-1 gap-14 lg:grid-cols-12">
      <div className="lg:col-span-7">
        <FadeUp className="glass inline-flex flex-wrap items-center gap-4 rounded-2xl px-6 py-4">
          <span className="font-display text-2xl font-black text-[#0A192F]">Nov 2016 – Mar 2017</span>
          <span className="h-8 w-px bg-[#0A192F]/15" />
          <span className="font-display text-sm font-bold uppercase tracking-[0.15em] text-[#0A192F]">
            IPCA — Group Product Manager
          </span>
        </FadeUp>

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-3" style={{ perspective: 1200 }}>
          {PORTFOLIO.map((p, i) => (
            <motion.div
              key={p.name}
              initial={{ opacity: 0, y: 40, rotateY: -14 }}
              whileInView={{ opacity: 1, y: 0, rotateY: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.12 }}
              whileHover={{ rotateY: 8, y: -8 }}
              className="glass rounded-3xl p-6"
            >
              <div className="flex h-24 items-center justify-center rounded-2xl bg-gradient-to-br from-[#0A192F] to-[#1B3A5C]">
                <span className="font-display text-xl font-black tracking-wide text-white">{p.name}</span>
              </div>
              <p className="mt-4 text-center text-xs font-semibold uppercase tracking-[0.14em] text-[#0A192F]/55">
                {p.mol}
              </p>
            </motion.div>
          ))}
        </div>

        <FadeUp delay={0.2} className="mt-8 max-w-xl text-sm leading-relaxed text-[#4A5568] md:text-base">
          Managed key Urology brands and helped the division launch its prostate cancer product — sharpening the craft
          of turning molecules into markets.
        </FadeUp>
      </div>

      <div className="lg:col-span-5">
        <FadeUp delay={0.1} className="rounded-[2rem] border border-[#0A192F]/10 bg-white p-8">
          <p className="text-[11px] font-bold uppercase tracking-[0.25em] text-[#0A192F]/45">The Product Chain</p>
          <div className="mt-6 space-y-1">
            {CHAIN.map((step, i) => (
              <motion.div
                key={step}
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
              >
                <div
                  className={`rounded-xl px-5 py-3 text-center font-display text-sm font-bold uppercase tracking-[0.16em] ${
                    i === CHAIN.length - 1 ? "bg-[#0A192F] text-[#00E5FF]" : "bg-[#0A192F]/[0.05] text-[#0A192F]"
                  }`}
                >
                  {step}
                </div>
                {i < CHAIN.length - 1 && (
                  <div className="flex justify-center py-1 text-[#00BFA5]">
                    <ArrowDown size={14} />
                  </div>
                )}
              </motion.div>
            ))}
          </div>
        </FadeUp>
      </div>
    </div>
  </ChapterShell>
);
